import React from "react"
import styled from 'styled-components';
import { IntlContextConsumer, changeLocale } from "gatsby-plugin-intl"

const languageName = {
    en: "Eng",
    ru: "Рус",
    uk: "Укр",
}
const LangList = styled.ul`
    display: flex;
    overflow: hidden;

    font-size: 14px;

    border: 1px solid var(--midle-gray1);
    border-radius: 20px;

    list-style: none;
    margin: 0 16px 0 0;
    padding: 0;
    li {
        &:not(:last-child) {
            border-right: 1px solid var(--midle-gray1);
        }
    }
`;
const LangLink = styled.a`
    width: 64px;
    padding: 4px 0;

    cursor: pointer;
    line-height: 1.43;
    text-align: center;

    &:hover,
    &:focus {
        color: var(--brand);
    }
`;
const CurrentLang = styled(LangLink)`
    cursor: default;
    
    color: #fff;
    background: var(--midle-gray1);
    &:hover,
    &:focus {
        color: #fff;
    }
`;

const LanguageSwitcherMob = () => {
    
    return (
        <IntlContextConsumer>
            {({ languages, language: currentLocale }) => (
                <LangList>
                    {languages.map(language => {
                        if (currentLocale === language) {
                            return <li key={language}><CurrentLang>
                                    {languageName[language]}
                            </CurrentLang></li>
                        } else {
                            return <li key={language}><LangLink 
                                onClick={() => changeLocale(language)}>
                                    {languageName[language]}
                            </LangLink></li>
                        }
                    })}
                </LangList>
                )
            }
        </IntlContextConsumer>
    )
}

export default LanguageSwitcherMob;